/** Begrenzt `value` auf das Intervall [min, max]. */
export function clamp(value: number, min: number, max: number): number {
  if (value < min) return min;
  if (value > max) return max;
  return value;
}

/**
 * Lineare Interpolation zwischen `a` und `b`: t = 0 ergibt `a`, t = 1 ergibt `b`.
 * `t` wird absichtlich nicht begrenzt, damit die Kamera zwischen zwei Ticks auch extrapolieren kann.
 */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}
